import { groupBy, transform } from 'lodash';

export class StringUtils {
	static BELGIUM_DUMMY_EID_CARD: any = {
		eidreader_version: '1.0.6',
		success: true,
		message: 'OK',
		carddata_os_number: '6',
		card_number: '593011663201',
		validity_begin_date: '05.10.2020',
		validity_end_date: '05.10.2030',
		issuing_municipality: 'Evere',
		national_number: '67022009547',
		surname: 'Elkafil',
		firstnames: 'Abdrahman',
		first_letter_of_third_given_name: '',
		nationality: 'Belge',
		location_of_birth: 'Gosselies',
		date_of_birth: '20 FEV  1967',
		gender: 'M',
		nobility: '',
		document_type: '01',
		special_status: '0',
		address_street_and_number: 'Rue de Locht 107 /ET02',
		address_zip: '1030',
		address_municipality: 'Schaerbeek',
		PHOTO_FILE:
			'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',
		eidreader_country: 'BE',
	};

	static groupBy = (array, group, ...restGroups) => {
		if (!group) return array;
		const currGrouping = groupBy(array, group);
		if (!restGroups.length) return currGrouping;
		return transform(
			currGrouping,
			(result, value, key) => {
				result[key] = StringUtils.groupBy(value, restGroups[0]);
			},
			{}
		);
	};

	static humanFileSize(bytes, si = false, dp = 1) {
		const thresh = 1024;

		if (Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}

		const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

		let u = -1;
		const r = 10 ** dp;

		do {
			bytes /= thresh;
			++u;
		} while (
			Math.round(Math.abs(bytes) * r) / r >= thresh &&
			u < units.length - 1
		);

		return bytes.toFixed(dp) + ' ' + units[u];
	}

	static keepDigitsOnly(str: string): string {
		return str ? str.replace(/\D/g, ''): '';
	}
}

export function logProductName(app: string) {
	console.log(
		`%cFire%c${app.toUpperCase()} %cv2.3.9`,
		'color:#ff026c;font-size:24px;font-weight:bold;font-family:Roboto,sans-serif;padding-left:24px',
		'color:#0178ff;font-size:24px;font-weight:bolder;font-family:Roboto,sans-serif;padding:24px 0;font-style:italic',
		'color:#ffffff;font-size:10px;font-weight:bold;font-family:Roboto,sans-serif;background:#354568;border-radius:8px;padding:2px 4px;vertical-align:start'
	);
}
